export async function ensureWebsocketDefined() {
    if (typeof global !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const g = global;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof g.WebSocket === 'undefined') {
            const { WebSocket: NodeWebSocket } = await import('ws');
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            g.WebSocket = NodeWebSocket;
        }
    }
}
//# sourceMappingURL=ensureWebsocketDefined.js.map